class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.notificationBg = document.querySelector('.cart-notification__bg');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.notificationBg.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notificationBg.classList.add('active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.notificationBg.classList.remove('active');

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, quantity = 1) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      if (section.id != 'cart-icon-bubble') {
        document.getElementById(section.id).innerHTML = this.getSectionHTML(
          parsedState.sections[section.id],
          section.selector
        ).innerHTML;
      } else {
        document.getElementById(section.id).querySelector('.cart-count-bubble').innerHTML = this.getSectionHTML(
          parsedState.sections[section.id],
          section.selector
        ).querySelector('.cart-count-bubble').innerHTML;
      }
    });

    document.querySelector(".cart-notification-quantity .add-quantity").innerHTML = `${quantity}`
    const price = Number(document.querySelector(".cart-notification-quantity").dataset.price.replace(",", "")) * quantity;
    document.querySelector(".cart-notification-quantity .sub-total-price").innerHTML = `${price}`;
    document.querySelector(".cart-notification__heading").innerHTML = "カートに商品を追加しました"
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
